import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IAdminConfirmDialogData {
  title: string;
  body: string;
  consequence: string;
  confirmLabel: string;
  destructive: boolean;
}

@Component({
  selector: 'admin-confirm-dialog',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class AdminConfirmDialogComponent {
  @Output() confirm = new EventEmitter<void>();

  submitting = false;
  errorMessage: string | null = null;

  constructor(
    protected _dialog_ref: MatDialogRef<AdminConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAdminConfirmDialogData,
    private _cdr: ChangeDetectorRef
  ) {}

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this._dialog_ref.close();
  }

  setSubmitting(submitting: boolean): void {
    this.submitting = submitting;
    this._cdr.markForCheck();
  }

  setError(message: string | null): void {
    this.errorMessage = message;
    this._cdr.markForCheck();
  }
}
